<template>
  <public-page>
    <div class="va-page-not-found justify--center" :style="pageNotFoundStyle">
      <div class="va-page-not-found__inner align--center">
        <div class="va-page-not-found-large-text__number" slot="image">404</div>
        <div class="va-page-not-found__title text--center">Page not found</div>
        <div class="va-page-not-found__text px-4 text--center">
          <span>
            If you feel that it’s not right, please send us a message at
          </span>
          <a href="mailto:rewardingdogtrain@gmail.com" :style="{color: this.$themes.primary}" class="link">rewardingdogtrain@gmail.com</a>
        </div>
        <va-button v-if="!withoutButton" :to="{ name: 'home' }">Back to site</va-button>
      </div>
    </div>
  </public-page>
</template>

<script>
import PublicPage from './PublicPage'
import { ColorThemeMixin } from '../../services/vuestic-ui'

const setOpenGraphMeta = require('./_helpers/openGraph.js')

export default {
  name: 'va-page-not-found',
  mixins: [ColorThemeMixin],
  inject: ['contextConfig'],
  components: { PublicPage },
  mounted () {
    setOpenGraphMeta({
      ogUrl: 'https://www.rewardingdogtraining.com/404',
      ogTitle: '404 - Rewarding Dog Training',
      ogDescription: 'Uh oh. Page not found. Must not have used enough rewards in your training to end up here',
    })
  },
  props: { withoutButton: Boolean },
  computed: {
    pageNotFoundStyle () {
      return {
        color: this.$themes.gray,
      }
    },
  },
}
</script>

<style lang="scss">
  .va-page-not-found {
    display: flex;
    margin-top: -4rem;

    &__inner {
      display: flex;
      flex-direction: column;

      .va-page-not-found-large-text {
        &__number {
          font-size: 16rem;
          color: $gray;
          font-weight: 600;

          @include media-breakpoint-down(xs) {
            font-size: 12rem;
          }
        }
      }
    }

    &__title {
      font-size: 3rem;
      line-height: 1.25em;
      font-weight: 500;

      @include media-breakpoint-down(xs) {
        font-size: 1.5rem;
      }
    }

    &__text {
      margin-bottom: 2.5rem;
    }
  }
</style>
